/*
 * Copyright (c) 2010, 2026 BSI Business Systems Integration AG
 *
 * This program and the accompanying materials are made
 * available under the terms of the Eclipse Public License 2.0
 * which is available at https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 */
import {IUserFilterStateDo, Table, TableUserFilter} from '../../index';

export abstract class UserFilterStateMapper<TFilter extends TableUserFilter = TableUserFilter, TFilterState extends IUserFilterStateDo = IUserFilterStateDo> {

  tryFromDo(table: Table, filterState: IUserFilterStateDo): TableUserFilter {
    if (this._acceptFilterState(filterState)) {
      return this._fromDo(table, filterState);
    }
    return null;
  }

  protected abstract _acceptFilterState(filterState: IUserFilterStateDo): filterState is TFilterState;

  protected abstract _fromDo(table: Table, filterState: TFilterState): TFilter;

  // ----------

  tryToDo(table: Table, filter: TableUserFilter): IUserFilterStateDo {
    if (this._acceptFilter(filter)) {
      return this._toDo(table, filter);
    }
    return null;
  }

  protected abstract _acceptFilter(filter: TableUserFilter): filter is TFilter;

  protected abstract _toDo(table: Table, filter: TFilter): TFilterState;
}
